import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, getCurrentInstance } from 'vue'
import systemParameter from '@/store/modules/systemParameter'
import { pdfBaseUrl } from '@/utils/env'
import ViewPdfModal from '@/components/ViewPdfModal.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationDetailDocuments',
  props: {
    insuranceUrl: null,
    hash: null,
    showInvoice: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  insuranceUrl?: string
  hash: string
  showInvoice: boolean
};

const { proxy } = getCurrentInstance()!
const $t = proxy.$t.bind(proxy)



const isInvoiceDialogOpen = ref(false)
const isInsuranceDialogOpen = ref(false)
const isW9DialogOpen = ref(false)

const close = () => {
  isInvoiceDialogOpen.value = false
  isInsuranceDialogOpen.value = false
  isW9DialogOpen.value = false
}

const isOpen = computed(() =>
  isInvoiceDialogOpen.value ||
  isInsuranceDialogOpen.value ||
  isW9DialogOpen.value
)

const w9Url = computed(() => systemParameter.w9Url)

const invoiceUrl = computed(() =>
  `https://${pdfBaseUrl()}/pdf/charterup-invoice/reservations?reservationHashes=${encodeURIComponent(
    [props.hash].join('')
  )}`
)

const fileName = computed(() => {
  if (isInvoiceDialogOpen.value) {
    return invoiceUrl.value
  }
  if (isInsuranceDialogOpen.value) {
    return props.insuranceUrl
  }
  if (isW9DialogOpen.value) {
    return w9Url.value
  }
  return ''
})

return { __sfc: true,proxy, $t, props, isInvoiceDialogOpen, isInsuranceDialogOpen, isW9DialogOpen, close, isOpen, w9Url, invoiceUrl, fileName, ViewPdfModal }
}

})